import { render } from "./BookmakerTable.vue?vue&type=template&id=8ffb5f70&scoped=true"
import script from "./BookmakerTable.vue?vue&type=script&lang=js"
export * from "./BookmakerTable.vue?vue&type=script&lang=js"

import "./BookmakerTable.vue?vue&type=style&index=0&id=8ffb5f70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffb5f70"]])

export default __exports__